import EditNoteIcon from "@mui/icons-material/Edit";
import { Box, Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import FollowUpReminderBanner from "../FollowUpReminderBanner";
import RequestFollowUpTimeline from "../RequestFollowUpTimeline";

const RequestFollowUpsTab = ({
  followUps = [],
  onRegisterClick,
  showRegisterButton = true,
}) => (
  <Box>
    <FollowUpReminderBanner
      followUps={followUps}
      onRegisterClick={onRegisterClick}
      showRegisterButton={showRegisterButton}
    />
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 1.5 }}
    >
      <Typography variant="subtitle2" fontWeight={700}>
        پیگیری‌های ثبت‌شده ({followUps.length})
      </Typography>
      {showRegisterButton && typeof onRegisterClick === "function" ? (
        <Button
          size="small"
          variant="contained"
          startIcon={<EditNoteIcon fontSize="small" />}
          onClick={onRegisterClick}
        >
          ثبت پیگیری
        </Button>
      ) : null}
    </Stack>
    <RequestFollowUpTimeline followUps={followUps} />
  </Box>
);

RequestFollowUpsTab.propTypes = {
  followUps: PropTypes.array,
  onRegisterClick: PropTypes.func,
  showRegisterButton: PropTypes.bool,
};

export default RequestFollowUpsTab;
